import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { homepageWidgetsClient } from '#pplx_generated/typespec/rest/homepage_widgets/client.js';
export const getHomepageUpsells = async (searchMode, options = {}) => {
    try {
        const { data, error, response } = await homepageWidgetsClient.GET('/rest/homepage-widgets/upsell', 'get upsells', {
            timeoutMs: getQueryTimeoutMs(),
            headers: { 'X-Search-Mode': searchMode },
            params: { query: { location: options.location } },
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return {
            upsell_information: data?.upsell_information ?? null,
            product_banner_information: data?.product_banner_information ?? null,
            input_upsell_information: data?.input_upsell_information ?? null,
        };
    }
    catch (error) {
        logger.error('Error getting homepage upsells', {
            error,
        });
        return {
            upsell_information: null,
            product_banner_information: null,
            input_upsell_information: null,
        };
    }
};
//# sourceMappingURL=getHomepageUpsells.js.map